import * as React from 'react';

function SvgBoardNotice(props) {
  return (
    <svg width={12} height={12} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.454 8.646L9.162 7.9a.186.186 0 00-.255.069l-.233.404a.187.187 0 00.068.256l1.293.746a.186.186 0 00.254-.07l.233-.403a.188.188 0 00-.068-.256zM8.906 4.031a.186.186 0 00.255.07l1.292-.747a.187.187 0 00.068-.256l-.232-.403a.187.187 0 00-.254-.069l-1.293.747a.187.187 0 00-.068.255l.232.403zm2.04 1.547h-1.5a.188.188 0 00-.188.188v.468c0 .104.084.188.187.188h1.5a.188.188 0 00.188-.188v-.468a.188.188 0 00-.188-.188zm-3.611-4.23c-.07 0-.14.018-.204.062L2.977 4.125H1.055a.188.188 0 00-.188.188v3.375c0 .103.085.187.188.187h1.922L7.13 10.59a.373.373 0 00.58-.314V1.724c0-.22-.18-.376-.376-.376z"
        fill="#6B92F3"
      />
    </svg>
  );
}

export default SvgBoardNotice;
